import { Component, Input } from "@angular/core";
import { ChatComponent } from "./chat.component";

@Component({
    selector: 'app-dicegroup',
    templateUrl: './dicegroup.component.html',
    styleUrls: ['./dicegroup.component.scss'],
    standalone: false
})
export class DiceGroupComponent {
    @Input() group!: any;
    @Input() ops!: string[];

    public getColor(op: string) {
        return ChatComponent.getColor(op);
    }
}